import { useState } from "react";
import toast from "react-hot-toast";
import { GETAPI, POSTAPI, POSTAPIFORMDATA } from "../api/Api";
import { ApiTypes } from "../constants/Constants";
import { renderFormData } from "./Helper";

const useMakeRequest = () => {
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(false);
    const [data, setData] = useState<any>(null);
    const [error, setError] = useState<any>(null);

    const makeRequest = async ({ payload = {}, url, type = ApiTypes?.POST, toastStatus = false }: {
        payload?: any,
        url: string,
        type?: 'POST' | 'GET' | 'FORM_DATA' | string,
        toastStatus?: boolean,
    }) => {
        try {
            setLoading(true);
            setStatus(false);
            setError(null);
            setData(null)

            let response;
            if (type === ApiTypes?.GET) {
                response = await GETAPI(url, payload, toastStatus);
            } else if (type === ApiTypes?.POST) {
                response = await POSTAPI(url, payload, toastStatus);
            } else if (type === ApiTypes?.FORM_DATA) {
                let payloadData = await renderFormData(payload);
                response = await POSTAPIFORMDATA(url, payloadData, toastStatus);
            }
            if (response?.status === true) {
                setStatus(true);
                setLoading(false);
                setError(null);
                setData(response)
                return response;
            } else {
                setStatus(false);
                setLoading(false);
                setError(response);
                setData(null)
                // return response?.message || 'Request failed!'
                throw new Error(response?.message || 'Request failed!');
            }
        } catch (error: any) {
            // return error?.message || 'Request failed!'
            throw new Error(error?.message || 'Request failed!');
        }
    };

    const reset = () => {
        setLoading(false);
        setStatus(false);
        setError(null);
        setData(null)
    }
    return { loading, data, error, status, reset, makeRequest };
};

export default useMakeRequest;


// const makeRequest = async ({ payload = {}, url, type = ApiTypes?.POST, toastStatus = false }: {
//     payload?: any,
//     url: string,
//     type?: string,
//     toastStatus?: boolean,
// }) => {
//     try {
//         setLoading(true);
//         setStatus(false);
//         setError(null);
//         setData(null)

//         const apiBaseUrl = process.env.NEXT_PUBLIC_API_URL;

//         let response = null;
//         if (type === ApiTypes?.GET) {
//             response = await GETAPI(url, payload, toastStatus);
//         } else if (type === ApiTypes?.POST) {
//             response = await POSTAPI(url, payload, toastStatus);
//         } else if (type === ApiTypes?.FORM_DATA) {
//             let payloadData = await renderFormData(payload);
//             response = await POSTAPIFORMDATA(url, payloadData, toastStatus);
//         }

//         if (response && response?.status == true) {
//             setStatus(true);
//             setLoading(false);
//             setError(null);
//             setData(response)
//         } else {
//             setStatus(false);
//             setLoading(false);
//             setError(response);
//             setData(null)
//         }
//     } catch (error: any) {
//         toast.error(error?.response?.data?.message)
//         setError(error);
//         setStatus(false);
//         setLoading(false);
//         setData(null);
//         throw error;
//     }
// };
